import { getCountryData, languages as languagesList } from "countries-list";

import { CountryCode, CountryOption } from "@/types";

export const getCountryOption = (countryCode: CountryCode): CountryOption => {
  if (countryCode === "GLOBAL") {
    return {
      iso2: "GLOBAL",
      languages: [],
      name: "Global",
      native: "Global"
    };
  } else {
    const { iso2, languages, name, native } = getCountryData(countryCode);

    return {
      iso2,
      languages: languages.map((languageCode) => ({
        ...languagesList[languageCode],
        iso2: languageCode
      })),
      name,
      native
    };
  }
};
